export * from './new-entidad-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/entidades-financieras/new-entidad-dialog/index.ts